export default "__VITE_ASSET__83cec0f7__"